import React from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react";
import { useTranslation } from "react-i18next";

interface IProps {
  onChange: (
    event: React.FormEvent<HTMLDivElement>,
    option?: IDropdownOption,
    index?: number
  ) => void;
  multiSelect: boolean;
  selectedKeys: string[] | number[] | null;
  selectedKey?: string | number | string[] | number[] | null;
  label?: string;
  placeholder?: string;
  required: boolean;
}
export default function OrderByDropdown(props: IProps) {
  const { t } = useTranslation();
  const options: any[] = [
    {
      key: 1,
      text: t("shared.sortByMostRecent"),
    },
    {
      key: 2,
      text: t("shared.sortByOldest"),
    },
    {
      key: 3,
      text: t("shared.sortByCreationDate"),
    },
  ];

  return <Dropdown {...props} options={options} style={{ width: "100%" }} />;
}

OrderByDropdown.defaultProps = {
  multiSelect: false,
  selectedKeys: null,
  selectedKey: null,
  label: null,
  placeholder: null,
  required: false,
};
